module.exports = __webpack_public_path__ + "media/file_icons/mov-93ea6822.png";